import 'assets/css/modal.css';
import 'styles/custom.css';
import * as React from 'react';
import { getRegionNames, updateBotMessageBatchSizeForSite, updateDefaultSetting } from "../components/Requests/Requests";
import { 
  StandardScreen,
  StandardSearchBox, 
  StandardDropdown, 
  StandardTextField,
  StandardButton, 
  StatusMessage,
  FormRow,
  StandardCheckbox,
  PageLayout
} from '../components/Layout';

class BotUtilities extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            error: "",
            spHostUrl: "",
            applyGlobalDefault: false,
            regionNameChosen: "",
            regionNames: "",
            batchSize: "",
            message: ""
        }
    }

    componentDidMount() {
        this.initializeSettings();
    }

    initializeSettings() {
        this.getRegionNames();
    }

    async getRegionNames() {
        this.setState({ loading: true })
        let response = await getRegionNames(this.props.accessToken);
        if (response.status === 200) {
            let data = await response.json();
            this.setState({
                loading: false,
                regionNames: data.map( item => 
                                    ({ key: item, text: item })),
            });
        } else {
            this.setState({ loading: false, error: "Something went wrong", message: "" });
        };
    }

    async updateDefaultBotMessageBatchSize(requestBody) {
              
        if (!this.state.batchSize || this.state.batchSize < 0 || this.state.batchSize > 2000) {
            this.setState({ error: "Please enter a valid batch size between 0 and 2000", message: "" });
            return;
        }
        this.setState({ loading: true })
        let response = await updateDefaultSetting(this.props.accessToken, requestBody);
        if (response.status === 200) {
            let data = await response.json();
            this.setState({ error: "", message: data.message, loading: false });
        } else if(response.status === 401){
            this.setState({ loading: false, error: "You are not permitted to use this feature. You must request admin permissions", message: "" });
        }
        else {
            this.setState({ loading: false, error: "Something went wrong", message: "" });
        };
    }

    async updateBotMessageBatchSizeForSite(requestBody) {
        if (!this.state.spHostUrl) {
            this.setState({ error: "Please enter a valid SPHostUrl", message: "" });
            return;
        }
        if (this.state.regionNameChosen === "") {
            this.setState({ error: "Please select an Environment", message: "" });
            return;
        }
        this.setState({ loading: true })
        let response = await updateBotMessageBatchSizeForSite(this.props.accessToken, requestBody);
        let data = await response.json();
        if (response.status === 200) {
                this.setState({ error: "", message: data.message, loading: false });

        }
        else if(response.status === 404){
            this.setState({ loading: false, error: "", message: data.message });
        }
        else {
            this.setState({ loading: false, error: "Something went wrong", message: "" });
        };
    }

    onSelectRegionName = (event, item) => {
        this.setState({ regionNameChosen: item.key });
    };

    onCheckApplyGlobalDefault = (event, checked) => {
        this.setState({
            applyGlobalDefault: checked,
            spHostUrl: "",
            regionNameChosen: null,
            error: "",
            message: ""
        });
    };

    onSpHostUrlChange = (newValue) => {
        this.setState({ 
            spHostUrl: newValue,
            error: "",
            message: ""
        });
    };

    onBatchSizeChange = (event, newValue) => {
        this.setState({ 
            batchSize: newValue,
            error: "",
            message: ""
        });
    };

    constructAndSendRequest() {

        let requestBody = {};

        if (this.state.applyGlobalDefault) {
            requestBody = {
                settingValue: this.state.batchSize === "" ? null : this.state.batchSize,
                settingName: "BotMessageBatchSize"
            };
            this.updateDefaultBotMessageBatchSize(requestBody);
        } else {
            requestBody = {
                spHostUrl: this.state.spHostUrl,
                regionName: this.state.regionNameChosen,
                batchSize: this.state.batchSize === "" ? null : this.state.batchSize
            };
            this.updateBotMessageBatchSizeForSite(requestBody);
        }
    }

    render() {
        const {
            loading,
            error,
            message,
            spHostUrl,
            applyGlobalDefault,
            regionNameChosen,
            regionNames,
            batchSize
        } = this.state;

        return (
            <PageLayout>
                <StandardScreen
                    title="Bot Message Pump Batch Size"
                    description="Change the default batch size for the message pump or for a specific host url, leave batch size as blank for specific host url to reset to default value"
                    loading={loading}
                >
                    <FormRow>
                        <StandardCheckbox
                            label="Update Globally"
                            checked={applyGlobalDefault}
                            onChange={this.onCheckApplyGlobalDefault}>
                        </StandardCheckbox>
                    </FormRow>

                    <StandardSearchBox
                        label="SPHostUrl"
                        placeholder="SPHostUrl"
                        value={spHostUrl}
                        onChange={this.onSpHostUrlChange}
                        disabled={applyGlobalDefault}
                    />

                    <StandardDropdown
                        label="Environment"
                        selectedKey={regionNameChosen}
                        onChange={this.onSelectRegionName}
                        placeholder="Select Environment"
                        options={regionNames}
                        disabled={applyGlobalDefault || this.state.spHostUrl === ""}
                    />

                    <StandardTextField
                        label="Size"
                        type="number"
                        placeholder="New Batch Size"
                        value={batchSize}
                        onChange={this.onBatchSizeChange}
                        disabled={!applyGlobalDefault && (this.state.spHostUrl === "" || this.state.regionNameChosen === "")}
                    />

                    <StandardButton
                        text="Submit"
                        onClick={() => this.constructAndSendRequest()}
                        disabled={(!applyGlobalDefault && (spHostUrl === "" || regionNameChosen === "")) || batchSize === ""}
                    />

                    {error && (
                        <StatusMessage type="error">{error}</StatusMessage>
                    )}

                    {message && (
                        <StatusMessage type="success">{message}</StatusMessage>
                    )}
                </StandardScreen>
            </PageLayout>
        );
    }
}

export default BotUtilities;